export default "__VITE_ASSET__l3mU1nG6__"